import { attempt as c } from "./contact-channels54.js";
import { NRLogger as s } from "./contact-channels45.js";
const f = async (r, o, n, p) => {
  const t = new URLSearchParams();
  t.append("tenant", r), t.append("locale", o), t.append("feature", n), t.append("checkAgentAvailability", "false");
  const { data: e, error: a } = await c(
    fetch(`https://global-channel-provider-service.care.vpsvc.com/v3/channels/chat?${t}`, {
      method: "GET",
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        "X-Api-Key": "Dz70ypBT7D1xRxqCCcUn71qH8iZ9qRiO3Ndbx2YU"
      }
    })
  );
  if (a)
    throw s.error("Contact Channels: Chat Info", {
      ...a,
      locale: o,
      tenant: r,
      feature: n,
      checkAgentAvailability: p
    }), new Error(`Network error: ${a}`);
  if (!e.ok)
    throw s.error("Contact Channels: Chat Info", { status: e.status, message: "Failed to fetch Chat Info" }), new Error(`HTTP error! Status: ${e.status}`);
  return e.json();
};
export {
  f as getChatInfo
};
//# sourceMappingURL=contact-channels53.js.map
